import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { List, ListItem, Button } from "@material-ui/core";
import useCacheDataMainTask from "hooks/useCacheDataMainTask";
import { taskIdSelector } from "views/JobDetailPage/selectors";
import { openDocumentDetail } from "actions/system/system";
import { getFileTabPart } from "actions/taskDetail/taskDetailActions";
import { getFileType } from "helpers/jobDetail/stringHelper";
import Collapse from "./Collapse";

const FileBox = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const project = useSelector(
    (state) => state.project.detailProject.data.project
  );
  const taskId = useSelector(taskIdSelector);
  const totalFile = useSelector(
    (state) => state.taskDetail.detailTask.taskDetails.total_file
  );
  const files = useCacheDataMainTask("taskDetail.media.detailFile", []);

  const filesRender = useMemo(() => files.reverse().slice(0, 3), [files]);

  useEffect(() => {
    if (taskId && taskId === project?.main_task) {
      dispatch(getFileTabPart({ taskId }));
    }
  }, [dispatch, project, taskId, totalFile]);

  function onClickFile(file, idx) {
    const type = getFileType(file.name);
    return () => {
      dispatch(openDocumentDetail({ ...file, type: type }));
    };
  }

  return (
    <Collapse
      classes="listPartTabBody--media listPartTabBody--files"
      label={t("LABEL_CHAT_TASK_FILE")}
    >
      {files.length > 0 ? (
        <>
          <List>
            {filesRender.map((item, idx) => {
              return (
                <ListItem className="fileBoxItem" key={item.id}>
                  <img
                    src={item.file_icon}
                    alt="avatar"
                    onClick={onClickFile(item, 0)}
                  />
                  <div className="fileBoxItem--content">
                    <div
                      className="fileBoxItem--name"
                      onClick={onClickFile(item, 0)}
                    >
                      {item.name}
                    </div>
                    <div className="fileBoxItem--bottom">
                      <span>{item.size}</span>
                      <span>{item.date_create}</span>
                    </div>
                  </div>
                </ListItem>
              );
            })}
          </List>
          <div className="btn-bottom">
            <Button
              fullWidth
              variant="contained"
              onClick={() => {
                props.setDefaultMediaTab(1);
                props.setShow(4);
              }}
            >
              {t("LABEL_CHAT_TASK_BTN_VIEW_ALL")}
            </Button>
          </div>
        </>
      ) : (
        <div className="btn-bottom">
          <div className="listPartTabBody--msg_empty_data">
            {t("LABEL_CHAT_TASK_EMPTY_FILE")}
          </div>
          <Button
            fullWidth
            variant="contained"
            onClick={() => document.getElementById("upload_image").click()}
          >
            {t("LABEL_CHAT_TASK_BTN_ADD_FILES")}
          </Button>
        </div>
      )}
    </Collapse>
  );
};

export default FileBox;
